module.exports = __webpack_public_path__ + "static/search-animation-62ba0ef46ee19b2f1daaba1a30ce2b76.gif";